module.exports = __webpack_public_path__ + "static/media/nimiia-cetii-artwork.e98b9740.jpg";